import React from 'react';
import { useNavigate } from 'react-router-dom';
import update from '../assets/images/update.png'

import updateImg from '../assets/images/upgrade_img_5.gif';
import Modal from "react-bootstrap/Modal";

const UpgradePlanPopup = ({ show, handleClose }) => {

    const navigate = useNavigate();

    const handleClick = () => {
        handleClose();
        // navigate('/cp-manage-plan');
    };
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop='static'
            keyboard={false}
            centered
            size='md'
        >
            <Modal.Header
                closeButton
                className='modal-header_box bg-my-primary p-3 d-flex justify-content-between modal-header'
            >
                <Modal.Title>Upgrade</Modal.Title>
            </Modal.Header>

            <Modal.Body className='pb-0'>
                <div className='text-center pt-2'>
                    {/* UNLOCK GIF */}
                    <div class="masking-container">
                        <h5 class="masked-text">TalentScan module is required to access candidate test features. Please upgrade to ATS + TalentScan to continue.</h5>
                    </div>
                    <div className='p-2'>
                        <img
                            src={updateImg}
                            alt='Unlock Feature'
                            className='shadow-lg rounded w-100'
                        />
                    </div>

                    {/* <div>
                        <button type='button' className='btn btn-warning'>
                            <div class="masking-container">
                                <h1 class="masked-text">Upgrade your plan</h1>
                            </div>
                        </button>
                    </div> */}
                    

                    {/* <h4 className='blue_dark_text font_weight_700'>
                        Upgrade Your Plan
                    </h4> */}
                    {/* <p className='text-muted'>
                        Unlock advanced features like Bulk Edit, Custom Reports, and Automation by upgrading your current plan.
                    </p> */}
                </div>
            </Modal.Body>

            <div className='text-center p-3'>
                {/* <button
                    className='btn btn-primary px-4'
                    onClick={handleClose}
                >
                    OK
                </button> */}
                <div className='d-inline-block rounded' style={{ background: "#ddd" }}>
                    <img
                        src={update}
                        alt='Unlock Feature'
                        className='shadow-lg rounded'
                        style={{
                            width: '100%',
                            maxWidth: '200px',
                            height: 'auto',
                            cursor: "pointer",
                        }}
                        onClick={handleClick}
                      
                    />
                </div>
            </div>
        </Modal>
    );
};

export default UpgradePlanPopup;
